import { FlexBox, Typography } from '@vp/swan'
import { useState } from 'react'
import type { Control } from 'react-hook-form'
import { Controller } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useUserContext } from '@vp/ubik-context'
import { OptionalIndicator } from '@shared/ui/form-label-indicators'
import type { IssueDescriptionFields } from '../../../../config/issue-description-fields'
import { useAppData } from '@app/providers'
import { OrderGroup } from '../orderSelectionField/order-group'
import { OrderSelectionLinks } from './order-selection-links'

interface Props {
  control: Control<IssueDescriptionFields>
}

export const OrderSelectionField = ({ control }: Props) => {
  const { t } = useTranslation()
  const { locale } = useUserContext()
  const { ordersData, fulfillmentData } = useAppData()

  const [visibleCount, setVisibleCount] = useState(1)

  if (!ordersData || ordersData.length === 0) return null

  const visibleOrders = ordersData.slice(0, visibleCount)
  const allOrdersVisible = visibleCount >= ordersData.length

  return (
    <FlexBox flexDirection="column" gap={2}>
      <Typography fontSkin="body-standard">
        {t('contact_us.page.steps.issue_description.item_label')}
        <OptionalIndicator />
      </Typography>

      <Controller
        name="selectedLineItemIds"
        control={control}
        render={({ field }) => {
          const selected = Array.isArray(field.value) ? field.value : []

          return (
            <FlexBox flexDirection="column" data-testid="order-number-selection-set">
              {visibleOrders.map((order) => (
                <OrderGroup key={order.orderId} order={order} selected={selected} onChange={field.onChange} fulfillmentData={fulfillmentData} locale={locale} />
              ))}

              <OrderSelectionLinks allOrdersVisible={allOrdersVisible} onShowMore={() => setVisibleCount((c) => c + 1)} />
            </FlexBox>
          )
        }}
      />
    </FlexBox>
  )
}
